import React, { useState } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { motion, AnimatePresence } from 'framer-motion';
import { FaQuoteLeft, FaGraduationCap, FaMapMarkerAlt, FaCalendarAlt, FaExternalLinkAlt, FaUsers, FaBookOpen, FaGlobe, FaChevronLeft, FaChevronRight, FaPlay } from 'react-icons/fa';

const experiences = [
  {
    id: 1,
    name: "Muhammet Safa Aydemir",
    department: "Matematik",
    program: "BIP - Theoretical and Numerical Analysis of Differential Equations and Their Applications",
    programType: "Blended Intensive Programme",
    country: "Avrupa",
    year: "2025",
    duration: "5 Gün",
    images: [
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/erasmusogrencideneyimi/download.jpg",
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/erasmusogrencideneyimi/ers2.jfif",
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/erasmusogrencideneyimi/ers3.jfif",
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/erasmusogrencideneyimi/ersm1.jfif"
    ],
    mainImage: "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/erasmusogrencideneyimi/download.jpg",
    quote: "Hem akademik anlamda kendimi geliştirdiğim hem de farklı ülkelerden gelen öğrencilerle tanışıp kültürel olarak da çok şey öğrendiğim unutulmaz bir deneyim oldu.",
    story: [
      "Yaz döneminde Erasmus+ kapsamında düzenlenen \"Theoretical and Numerical Analysis of Differential Equations and Their Applications\" isimli BIP (Blended Intensive Programme) etkinliğine katılma şansı yakaladım. Hem akademik anlamda kendimi geliştirdiğim hem de farklı ülkelerden gelen öğrencilerle tanışıp kültürel olarak da çok şey öğrendiğim unutulmaz bir deneyim oldu.",
      "Etkinlik boyunca diferansiyel denklemler üzerine teorik bilgiler edindik, bu denklemlerin sayısal çözümleri üzerine çalıştık ve çeşitli uygulamalar gördük. Nümerik analiz alanına ilgim zaten vardı ama bu program sayesinde daha derinlemesine bir bakış kazandım. Akademisyenlerin konuları anlatım biçimi ve bizimle kurduğu iletişim de oldukça motive ediciydi.",
      "Programın en güzel yanlarından biri de uluslararası bir ortamda bulunmaktı. Farklı ülkelerden gelen katılımcılarla birlikte çalışmak, sohbet etmek, hem akademik hem de sosyal anlamda kendimi geliştirmeme katkı sağladı. Grup çalışmaları, sunumlar ve sosyal etkinliklerle dolu dolu geçen 5 gündü.",
      "Benim için oldukça verimli ve ilham verici bir süreçti. Bu tarz programlara katılmayı düşünen herkese kesinlikle tavsiye ederim. Yeni şeyler öğrenmek, akademik çevreyi genişletmek ve farklı kültürlerle tanışmak için harika bir fırsat."
    ]
  },
  {
    id: 2,
    name: "Nurten Ünlerşen",
    department: "Matematik",
    program: "BIP - Cagliari Üniversitesi Erasmus Programı",
    programType: "Blended Intensive Programme",
    country: "İtalya",
    year: "2025",
    duration: "5 Gün",
    images: [
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/nurtenunlersen1.jpg",
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/nurtenunlersen2_1.jpg",
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/nurtenunlersen3_1.jpg"
    ],
    mainImage: "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/nurtenunlersen1.jpg",
    quote: "Cagliari Üniversitesi'nde katıldığım Erasmus BIP programı, akademik ve sosyal açıdan benim için son derece değerli bir deneyim oldu.",
    story: [
      "Cagliari Üniversitesi'nde katıldığım Erasmus BIP programı, akademik ve sosyal açıdan benim için son derece değerli bir deneyim oldu. Yoğun ancak oldukça öğretici geçen program boyunca diferansiyel denklemler konusunu daha detaylı bir şekilde öğrenme fırsatı buldum.",
      "Alanında uzman akademisyenlerden dersler almak, konuları farklı bakış açılarıyla değerlendirme imkânı sundu. Bunun yanı sıra, çok uluslu bir ortamda bulunmak hem keyifli hem de ilham verici bir deneyimdi.",
      "Farklı ülkelerden gelen öğrencilerle etkileşim kurarak, yalnızca akademik bilgi değil, aynı zamanda farklı kültürleri tanıma ve yeni bakış açıları kazanma şansı elde ettim.",
      "Cagliari Üniversitesi'nde geçirdiğim bu süre, hayatımın en değerli akademik ve kültürel deneyimlerinden biri olarak benim için kalıcı bir anlam taşıyor."
    ]
  },
  {
    id: 3,
    name: "Cemre Demirtaş",
    department: "Matematik",
    program: "BIP - Theoretical and Numerical Analysis of Differential Equations and Their Applications",
    programType: "Blended Intensive Programme",
    country: "Avrupa",
    year: "2025",
    duration: "5 Gün",
    images: [
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/cemredemirtas1.jfif",
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/cemredemirtas2.jfif",
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/cemredemirtas3.jfif",
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/cemredemirtas4.jfif"
    ],
    mainImage: "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/cemredemirtas1.jfif",
    quote: "Programda hocaların dersleri ilgimi çok çekti; bilmediğim yeni bilgiler öğrendim ve konulara olan merakım daha da pekişti.",
    story: [
      "Erasmus+ BIP programı kapsamında katıldığım \"Theoretical and Numerical Analysis of Differential Equations and Their Applications\" başlıklı etkinlik, hem akademik hem de kişisel açıdan oldukça değerli bir deneyim oldu. Programda hocaların dersleri ilgimi çok çekti; bilmediğim yeni bilgiler öğrendim ve konulara olan merakım daha da pekişti.",
      "Ayrıca derslerin İngilizce olması ve diğer öğrencilerle İngilizce iletişim kurmam, dil becerilerimin gelişmesine büyük katkı sağladı. Akademik katkılarının yanı sıra, programın sosyal boyutu da benim için çok önemliydi.",
      "İspanyol ve İtalyan öğrencilerle çok güzel arkadaşlıklar kurdum; ayrıca İspanya ve İtalya'dan değerli hocalarla bağlantılar geliştirme fırsatı buldum ve onların bilgi ve tecrübelerinden yararlandım. Bunun yanında, farklı kültürleri tanıma ve uluslararası bir ortamda fikir alışverişinde bulunma imkanı, bana hem kişisel hem de profesyonel anlamda önemli kazanımlar sağladı.",
      "Genel olarak bu etkinlik, akademik gelişimime katkıda bulunurken aynı zamanda dil becerilerimi, uluslararası iş birliklerini ve kültürel deneyimlerimi zenginleştirerek ufkumu genişletti."
    ]
  },
  {
    id: 4,
    name: "Tolga Topçuoğlu",
    department: "Matematik",
    program: "BIP - Theoretical and Numerical Analysis of Differential Equations and Their Applications",
    programType: "Blended Intensive Programme",
    country: "Avrupa",
    year: "2025",
    duration: "5 Gün",
    images: [
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/tolgatopcuoglu1.jfif",
      "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/tolgatopcuoglu2.jfif"
    ],
    mainImage: "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/tolgatopcuoglu1.jfif",
    quote: "Önceki Erasmus deneyimime kıyasla, yalnızca bir haftalık bu yoğun programda çok fazla şey yaşadığımı söyleyebilirim.",
    story: [
      "Erasmus+ Karma Yoğun Program (BIP) kapsamında katıldığım \"Theoretical and Numerical Analysis of Differential Equations and Their Applications\" başlıklı etkinlik, akademik ve kişisel açıdan bana çok değerli katkılar sağladı. Bu fırsat sayesinde hem alanımla ilgili teorik bilgimi geliştirme imkânı buldum hem de uluslararası bir ortamda farklı bakış açıları kazanarak kendimi daha iyi tanıma şansı elde ettim.",
      "Önceki Erasmus deneyimime kıyasla, yalnızca bir haftalık bu yoğun programda çok fazla şey yaşadığımı söyleyebilirim. Her yerin, her insanın ve her kültürün bana kattığı farklı bir tecrübe oldu. Bu çeşitlilik, kısa sürede çok yönlü bir gelişim yaşamama vesile oldu.",
      "Program boyunca özellikle diferansiyel denklemlerin teorik ve sayısal yöntemlerle incelenmesi üzerine verilen dersler, matematik bilgimi derinleştirmemin yanı sıra bilgisayar uygulamalarıyla pratiğe dökmeme de yardımcı oldu. Önceden bu konularda teorik bir eğitim almış olsam da, geçmiş dönemlerde aldığım nümerik analiz dersinde edindiğim bilgileri burada kullanarak uygulamaya yönelik ilgimin çok daha fazla olduğunu fark ettim.",
      "Akademik kazanımların dışında, uluslararası bir ortamda bulunmak bana çok değerli sosyal deneyimler de kazandırdı. Farklı kültürlerden öğrencilerle bir araya gelmek, onların eğitim sistemlerini, bakış açılarını ve hayat tarzlarını tanımak ufkumu genişletti. Bu program, bana yalnızca matematiksel ve teknik açıdan katkı sağlamakla kalmadı, aynı zamanda özgüvenimi artırdı ve gelecekte uluslararası akademik çalışmalara katılma konusunda motivasyon verdi."
    ]
  }
];

const ImageGallery = ({ images, name }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <>
      <div className="relative group">
        <div className="relative w-full h-48 sm:h-60 lg:h-80 rounded-2xl overflow-hidden shadow-2xl">
          <img 
            src={images[currentImage]} 
            alt={`${name} - ${currentImage + 1}`}
            className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
            onError={(e) => {
              e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxjaXJjbGUgY3g9IjIwMCIgY3k9IjE1MCIgcj0iNDAiIGZpbGw9IiM5Q0E0QUYiLz4KPHBhdGggZD0iTTE4NSAxMzVIMjE1VjE2NUgxODVWMTM1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+";
            }}
          />
          
          {/* Navigation arrows */}
          {images.length > 1 && (
            <>
              <button
                onClick={prevImage}
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-300 opacity-0 group-hover:opacity-100"
              >
                <FaChevronLeft />
              </button>
              <button
                onClick={nextImage}
                className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-300 opacity-0 group-hover:opacity-100"
              >
                <FaChevronRight />
              </button>
            </>
          )}

          {/* Fullscreen button */}
          <button
            onClick={() => setIsFullscreen(true)}
            className="absolute top-4 right-4 bg-black/50 hover:bg-black/70 text-white p-2 rounded-lg transition-all duration-300 opacity-0 group-hover:opacity-100"
          >
            <FaExternalLinkAlt />
          </button>

          {/* Image counter */}
          {images.length > 1 && (
            <div className="absolute bottom-4 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm">
              {currentImage + 1} / {images.length}
            </div>
          )}
        </div>

        {/* Thumbnail navigation */}
        {images.length > 1 && (
          <div className="flex gap-2 sm:gap-3 mt-3 sm:mt-4 lg:mt-6 justify-start overflow-x-auto pb-2 px-1" style={{scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch'}}>
            {images.map((img, index) => (
              <button
                key={index}
                onClick={() => setCurrentImage(index)}
                className={`flex-shrink-0 w-14 h-10 sm:w-20 sm:h-14 lg:w-24 lg:h-18 rounded-lg overflow-hidden border-2 transition-all duration-300 shadow-sm hover:shadow-md ${
                  currentImage === index ? 'border-blue-500 ring-1 ring-blue-200' : 'border-gray-300 hover:border-gray-400'
                }`}
              >
                <img src={img} alt={`${index + 1}`} className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Fullscreen modal */}
      <AnimatePresence>
        {isFullscreen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
            onClick={() => setIsFullscreen(false)}
          >
            <motion.div
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              className="relative max-w-6xl max-h-full"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={images[currentImage]}
                alt={`${name} - Fullscreen`}
                className="max-w-full max-h-full object-contain rounded-lg"
              />
              <button
                onClick={() => setIsFullscreen(false)}
                className="absolute top-4 right-4 bg-black/50 text-white p-2 rounded-lg hover:bg-black/70 transition-colors"
              >
                ✕
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

const cardVariants = {
  hidden: { opacity: 0, y: 80 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  }),
};

const fadeInVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' }
  }
};

const ErasmusOgrenciDeneyimleri = () => {
  return (
    <PageTemplate
      title="Öğrenci Deneyimleri"
      subtitle="Erasmus+ programıyla yurt dışında eğitim almış öğrencilerimizin gerçek deneyimlerini keşfedin ve siz de bu benzersiz fırsatın parçası olun."
    >
      <div className="space-y-6 sm:space-y-8 lg:space-y-12 xl:space-y-20 px-1 sm:px-0">
        {/* Modern Hero Section */}
        <motion.div 
          className="relative bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-4 sm:p-6 lg:p-8 rounded-2xl sm:rounded-3xl border border-blue-100 overflow-hidden"
          variants={fadeInVariants}
          initial="hidden"
          animate="visible"
        >
          <div className="hidden sm:block absolute top-0 right-0 w-32 h-32 sm:w-48 sm:h-48 lg:w-64 lg:h-64 bg-gradient-to-br from-blue-100/30 to-purple-100/30 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="relative z-10">
            <div className="flex flex-col sm:flex-row items-start sm:items-center mb-4 sm:mb-6 gap-3 sm:gap-4">
              <div className="p-2 sm:p-3 bg-blue-600 rounded-xl flex-shrink-0">
                <FaGraduationCap className="text-white text-xl sm:text-2xl" />
              </div>
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-800 break-words">Gerçek Deneyimler, Gerçek Hikayeler</h2>
            </div>
            <p className="text-gray-700 leading-relaxed text-sm sm:text-base lg:text-lg max-w-4xl hyphens-auto">
              Hacettepe Üniversitesi Fen Fakültesi öğrencilerimizin Erasmus+ programı kapsamında yaşadıkları 
              unutulmaz deneyimleri sizlerle paylaşıyoruz. Bu hikayeler, uluslararası eğitimin sunduğu 
              fırsatları ve kişisel gelişime katkılarını gözler önüne seriyor.
            </p>
          </div>
        </motion.div>

        {/* Featured Experience */}
        {experiences.map((experience, index) => (
          <motion.div
            key={experience.id}
            className="bg-white rounded-2xl sm:rounded-3xl shadow-lg sm:shadow-2xl overflow-hidden border border-gray-100 mx-1 sm:mx-0"
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={index}
          >
            {/* Header with gradient */}
            <div className="bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 p-3 sm:p-4 lg:p-6 xl:p-8 text-white">
              <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-white/20 rounded-lg">
                      <FaGraduationCap className="text-2xl" />
                    </div>
                    <span className="bg-white/20 px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs sm:text-sm font-medium break-words">
                      {experience.programType}
                    </span>
                  </div>
                  <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold mb-1 sm:mb-2 break-words leading-tight">{experience.name}</h3>
                  <h4 className="text-base sm:text-lg lg:text-xl font-medium text-blue-100 mb-3 sm:mb-4">{experience.department} Bölümü</h4>
                  <div className="flex flex-wrap gap-1 sm:gap-2 lg:gap-4 text-xs sm:text-sm">
                    <div className="flex items-center bg-white/10 px-2 sm:px-3 py-0.5 sm:py-1 rounded-full">
                      <FaCalendarAlt className="mr-1 sm:mr-2 text-xs" />
                      <span>{experience.year}</span>
                    </div>
                    <div className="flex items-center bg-white/10 px-2 sm:px-3 py-0.5 sm:py-1 rounded-full">
                      <FaGlobe className="mr-1 sm:mr-2 text-xs" />
                      <span>{experience.duration}</span>
                    </div>
                    <div className="flex items-center bg-white/10 px-2 sm:px-3 py-0.5 sm:py-1 rounded-full">
                      <FaUsers className="mr-1 sm:mr-2 text-xs" />
                      <span className="hidden sm:inline">Uluslararası Program</span>
                      <span className="sm:hidden">Program</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-3 sm:p-4 lg:p-6 xl:p-12">
              {/* Program Title */}
              <div className="mb-4 sm:mb-6 lg:mb-8">
                <h4 className="text-sm sm:text-lg lg:text-xl xl:text-2xl font-bold text-gray-800 mb-2 flex items-start gap-2 leading-tight">
                  <FaBookOpen className="text-blue-600 flex-shrink-0 mt-0.5 text-sm sm:text-base" />
                  <span className="break-words hyphens-auto">{experience.program}</span>
                </h4>
              </div>

              <div className="flex flex-col lg:grid lg:grid-cols-5 gap-4 sm:gap-6 lg:gap-8">
                {/* Image Gallery */}
                <div className="lg:col-span-2 w-full">
                  <ImageGallery images={experience.images} name={experience.name} />
                </div>

                {/* Content */}
                <div className="lg:col-span-3 space-y-4 sm:space-y-6 lg:space-y-8 w-full">
                  {/* Quote */}
                  <div className="relative bg-gradient-to-r from-blue-50 to-indigo-50 p-3 sm:p-4 lg:p-6 rounded-xl sm:rounded-2xl border border-blue-100">
                    <FaQuoteLeft className="text-blue-500 text-lg sm:text-xl mb-2 sm:mb-3" />
                    <p className="text-gray-800 text-sm sm:text-base lg:text-lg leading-relaxed italic font-medium break-words hyphens-auto">
                      "{experience.quote}"
                    </p>
                    <div className="absolute -right-1 -bottom-1 sm:-right-2 sm:-bottom-2 w-4 h-4 sm:w-6 sm:h-6 lg:w-8 lg:h-8 bg-blue-500 rounded-full opacity-10"></div>
                  </div>


                  {/* Story */}
                  <div>
                    <div className="space-y-2 sm:space-y-3 lg:space-y-4">
                      {experience.story.map((paragraph, idx) => (
                        <p key={idx} className="text-gray-700 text-xs sm:text-sm lg:text-base leading-relaxed text-left sm:text-justify break-words hyphens-auto">
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        ))}

        {/* Call to Action */}
        <motion.div 
          className="relative bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 text-white p-6 sm:p-8 lg:p-12 rounded-3xl text-center overflow-hidden"
          variants={fadeInVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <div className="absolute top-0 left-0 w-full h-full">
            <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-white/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-1/4 right-1/4 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>
          </div>
          <div className="relative z-10">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6">Siz de Bu Deneyimin Parçası Olun!</h3>
            <p className="text-blue-100 mb-6 sm:mb-8 max-w-3xl mx-auto text-base sm:text-lg leading-relaxed px-2">
              Erasmus+ programı hakkında detaylı bilgi almak ve başvuru süreçleri için 
              AB Ofisi'ni ziyaret edin. Hayalinizdeki üniversitede eğitim alma fırsatı sizi bekliyor!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://abofisi.hacettepe.edu.tr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-blue-700 font-bold py-4 px-8 rounded-2xl hover:bg-blue-50 transition-all duration-300 inline-flex items-center justify-center shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                <FaExternalLinkAlt className="mr-2" />
                AB Ofisi'ne Git
              </a>
              <a 
                href="/programlar/erasmus" 
                className="bg-blue-500 text-white font-bold py-4 px-8 rounded-2xl hover:bg-blue-400 transition-all duration-300 inline-flex items-center justify-center shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                <FaPlay className="mr-2" />
                Erasmus+ Programı
              </a>
            </div>
          </div>
        </motion.div>

        {/* Modern Statistics */}
        <motion.div 
          className="grid grid-cols-1 sm:grid-cols-3 gap-6"
          variants={fadeInVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {[
            { number: "200+", label: "Erasmus+ Öğrencisi", color: "blue", icon: FaGraduationCap },
            { number: "30+", label: "Partner Üniversite", color: "green", icon: FaGlobe },
            { number: "20+", label: "Ülke", color: "purple", icon: FaMapMarkerAlt }
          ].map((stat, index) => (
            <div key={index} className="relative group">
              <div className={`text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 group-hover:-translate-y-2`}>
                <div className={`inline-flex p-4 rounded-2xl bg-${stat.color}-100 mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <stat.icon className={`text-2xl text-${stat.color}-600`} />
                </div>
                <div className={`text-4xl font-bold text-${stat.color}-600 mb-2`}>{stat.number}</div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </PageTemplate>
  );
};

export default ErasmusOgrenciDeneyimleri;